<template lang="pug">
.template-view-item-component
  .section-and-group(v-if="isSection(value) || isGroup(value)" :class="_margin")
    //- type: section
    .template-item.d-flex.flex-column(v-if="isSection(value)")
      .d-flex.flex-row
        .section-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .section-text(v-if="value.text" v-html="formatTextWithLink(value.text)")
      .section-text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")
      .mb-2
      .section-items
        .section-item(v-for="(property, index) in value.properties" :key="property.id")
          WaiterTemplateItem(v-model="value.properties[index]" :waiterViewableFacilitiesMap="waiterViewableFacilitiesMap" :isChaild="true")

    //- type: group
    .template-group-item.d-flex.flex-column.mb-3(v-if="isGroup(value)")
      .d-flex.flex-row
        .section-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .section-text(v-if="value.text" v-html="formatTextWithLink(value.text)")
      .section-text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")
      .mb-2
      .group-items(v-for="(property, index) in value.properties" :key="value.id + '-' + index")
        .group-item.pt-2.pb-2.mb-2
          .group-child-item(v-for="(childProperty, childIndex) in property" :key="value.id + '-' + index + '-' + childIndex")
            WaiterTemplateItem(v-model="value.properties[index][childIndex]" :waiterViewableFacilitiesMap="waiterViewableFacilitiesMap" :isChaild="true")

  .template-items(v-else :class="{ 'facility-only': value.displayToUser == false }").mr-3.mb-3.ml-3
    //- type: text
    .template-item.d-flex.flex-column.mb-2(v-if="isText(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text" v-html="formatTextWithLink(value.text)")
        .text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")

      .item-text.d-flex.flex-row
        .text-prefix.mr-2(v-if="value.prefix") {{ value.prefix }}
        span.warning-message(v-if="value.answer == null") 未入力
        span(v-else) {{ value.answer }}
        .text-suffix.ml-2 {{ value.suffix }}

    //- type: radio
    .template-item.d-flex.flex-column.mb-2(v-if="isRadio(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text" v-html="formatTextWithLink(value.text)")
        .text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")
      .radio-item
        span.warning-message(v-if="value.answer == null") 未入力
        span(v-else) {{ getRadioText(value) }}

    //- type: radioGroup
    .template-item-radio-group.d-flex.flex-column.mb-2(v-if="isRadioGroup(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text" v-html="formatTextWithLink(value.text)")
        .text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")
      .radio-item
        span.warning-message(v-if="value.answer == null") 未入力
      
      .radio-items(v-for="(property, index) in value.properties")
        template(v-if="value.answer == property.option.value")
          .radio-item
            span {{ property.option.text }}
          .radio-properties.pt-2.mt-2(v-if="property.properties && 0 < property.properties.length")
            .group-child-item(v-for="(childProperty, childIndex) in property.properties")
              WaiterTemplateItem(v-model="value.properties[index].properties[childIndex]" :waiterViewableFacilitiesMap="waiterViewableFacilitiesMap" :isChaild="true")

    //- type: select
    .template-item-select.d-flex.flex-column.mb-2(v-if="isSelect(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text" v-html="formatTextWithLink(value.text)")
        .text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")

      .select-item
        span.warning-message(v-if="value.answer == null") 未入力
        span(v-else) {{ getSelectText(value) }}

    //- type: checkbox
    .template-item-checkbox.d-flex.flex-column.mb-2(v-if="isCheckbox(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text" v-html="formatTextWithLink(value.text)")
        .text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")

      .d-flex.flex-row.align-items-center
        img.checkbox.mr-1(v-if="value.answer == null" src="@/assets/login-checkbox-off.png")
        img.checkbox.mr-1(v-if="value.answer == false" src="@/assets/login-checkbox-off.png")
        img.checkbox.mr-1(v-if="value.answer == true" src="@/assets/login-checkbox-on.png")
        span {{ value.question }}

    //- type: siwtch checkbox
    .template-item-switch-checkbox.d-flex.flex-column(v-if="isSwitchCheckbox(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text" v-html="formatTextWithLink(value.text)")
        .text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")

      .d-flex.flex-row.align-items-center
        img.checkbox.mr-1(v-if="value.answer == null" src="@/assets/login-checkbox-off.png")
        img.checkbox.mr-1(v-if="value.answer == false" src="@/assets/login-checkbox-off.png")
        img.checkbox.mr-1(v-if="value.answer == true" src="@/assets/login-checkbox-on.png")
        span {{ value.question }}

      .checkbox-items.mt-2.mb-2(v-if="value.showRule == value.answer || (value.showRule == false && value.answer == null)")
        .checkbox-property.pt-2.mt-2(v-for="(property, index) in value.properties" :key="value.id + '-' + index")
          WaiterTemplateItem(v-model="value.properties[index]" :waiterViewableFacilitiesMap="waiterViewableFacilitiesMap" :isChaild="true")

    //- type: multipleCheckbox
    .template-item-checkbox.d-flex.flex-column.mb-2(v-if="isMultipleCheckbox(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text" v-html="formatTextWithLink(value.text)")
        .text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")

      .d-flex.flex-row.align-items-center.mb-2(v-for="(question, index) in value.questions")
        img.checkbox.mr-1(v-if="value.answer[index] == null" src="@/assets/login-checkbox-off.png")
        img.checkbox.mr-1(v-if="value.answer[index] == false" src="@/assets/login-checkbox-off.png")
        img.checkbox.mr-1(v-if="value.answer[index] == true" src="@/assets/login-checkbox-on.png")
        span {{ value.questions[index] }}

    //- type: textarea
    .template-item-textarea.d-flex.flex-column.mb-2(v-if="isTextarea(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text" v-html="formatTextWithLink(value.text)")
        .text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")
      .item-textarea
        span.warning-message(v-if="value.answer == null") 未入力
        span.textarea(v-else) {{ value.answer }}

    //- type: address
    .template-item-address.d-flex.flex-column.mb-2(v-if="isAddress(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text" v-html="formatTextWithLink(value.text)")
        .text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")

      .d-flex.flex-column
        .d-flex.flex-row
          span 郵便番号：
          span.warning-message(v-if="!value.answer || !value.answer.postalCode") 未入力
          span(v-else) {{ value.answer.postalCode }}
        .d-flex.flex-row
          span 住所：
          span.warning-message(v-if="!value.answer || !value.answer.address") 未入力
          span(v-else) {{ value.answer.address }}

    //- type: birthday
    .template-item-birthday.d-flex.flex-column.mb-2(v-if="isBirthday(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text" v-html="formatTextWithLink(value.text)")
        .text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")

      .d-flex.flex-row.align-items-center
        span.warning-message.mr-2(v-if="!value.answer || !value.answer.year") 未入力
        span.mr-2(v-else) {{ value.answer.year }}
        span.mr-2 年

        span.warning-message.mr-2(v-if="!value.answer || !value.answer.month") 未入力
        span.mr-2(v-else) {{ value.answer.month }}
        span.mr-2 月

        span.warning-message.mr-2(v-if="!value.answer || !value.answer.date") 未入力
        span.mr-2(v-else) {{ value.answer.date }}
        span.mr-2 日

        span(v-if="value.answer && value.answer.month && value.answer.date ") （{{ createAge(value) }}歳）

    //- type: yearMonthDate
    .template-item-year-month-date.mb-2(v-if="isYearMonthDate(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text" v-html="formatTextWithLink(value.text)")
        .text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")

      .d-flex.flex-row.align-items-center
        span.warning-message.mr-2(v-if="!value.answer || !value.answer.year") 未入力
        span.mr-2(v-else) {{ value.answer.year }}
        span.mr-2 年

        span.warning-message.mr-2(v-if="!value.answer || !value.answer.month") 未入力
        span.mr-2(v-else) {{ value.answer.month }}
        span.mr-2 月

        span.warning-message.mr-2(v-if="!value.answer || !value.answer.date") 未入力
        span.mr-2(v-else) {{ value.answer.date }}
        span.mr-2 日

        span.mr-2(v-if="value.suffix") {{ value.suffix }}

    //- type: yearMonth
    .template-item-year-month-date.mb-2(v-if="isYearMonth(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text" v-html="formatTextWithLink(value.text)")
        .text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")

      .d-flex.flex-row.align-items-center
        span.warning-message.mr-2(v-if="!value.answer || !value.answer.year") 未入力
        span.mr-2(v-else) {{ value.answer.year }}
        span.mr-2 年
        span.warning-message.mr-2(v-if="!value.answer || !value.answer.month") 未入力
        span.mr-2(v-else) {{ value.answer.month }}
        span.mr-2 月
        span.mr-2(v-if="value.suffix") {{ value.suffix }}

    //- type: roomType
    .template-item-room-type.mb-2(v-if="isRoomType(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text" v-html="formatTextWithLink(value.text)")
        .text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")

      .facility-recruitment(v-for="(checkbox, index) in value.answer")
        span.facility-name(v-if="showRecruitement(value.answer[index]) || showCustomRecruitment(value.answer[index])") ・{{ getFacilityName(value.answer[index]) }}
        .checkboxs.ml-3(v-if="showRecruitement(value.answer[index])")
          .checkbox(v-if="value.answer[index].recruitmentRoom.multiBed") 従来型多床室
          .checkbox(v-if="value.answer[index].recruitmentRoom.conventinalSingle") 従来型個室
          .checkbox(v-if="value.answer[index].recruitmentRoom.unitTypeSingle") ユニット型個室
          .checkbox(v-if="value.answer[index].recruitmentRoom.single") 個室
          .checkbox(v-if="value.answer[index].recruitmentRoom.double") ２人部屋（夫婦部屋）
        .checkboxs.ml-3(v-if="showCustomRecruitment(value.answer[index])")
          .checkbox(v-if="room.use" v-for="room in value.answer[index].customRecruitmentRoom") {{ room.name }}

    //- type: file
    .template-item-file.mb-2(v-if="isFile(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text" v-html="formatTextWithLink(value.text)")
        .text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")
        span.error-message(v-show="fileErrorMesage") {{ fileErrorMesage }}

      template(v-for="(file, index) in value.answer")
        span.warning-message(v-if="file == null") 未入力
        .d-flex.flex-row.align-items-center(v-else)
          span.mr-2 {{ file.name }}
          button.btn.file-preview-btn(@click="onFilePreview(value, index)") プレビュー
        .mb-2(v-if="(index + 1) != value.answer.length")

      PdfModal(v-model="showPdfModal" :pdfUrl="pdfModalUrl")
      ImageModal(v-model="showImageModal" :imageUrl="imageModalUrl")

    //- type: tel
    .template-item.d-flex.flex-column.mb-2(v-if="isTel(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text" v-html="formatTextWithLink(value.text)")
        .text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")

      .d-flex.flex-row.align-items-center
        span.warning-message.mr-2(v-if="!value.answer || !value.answer.first") 未入力
        span.mr-2(v-else) {{ value.answer.first }}
        span.mr-2 －
        span.warning-message.mr-2(v-if="!value.answer || !value.answer.second") 未入力
        span.mr-2(v-else) {{ value.answer.second }}
        span.mr-2 －
        span.warning-message.mr-2(v-if="!value.answer || !value.answer.third") 未入力
        span.mr-2(v-else) {{ value.answer.third }}

    //- type: name
    .template-item.d-flex.flex-column.mb-2(v-if="isName(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text" v-html="formatTextWithLink(value.text)")
        .text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")

      .d-flex.flex-row.align-items-center
        span.warning-message.mr-2(v-if="!value.answer || !value.answer.secondName") 未入力
        span.mr-2(v-else) {{ value.answer.secondName }}
        span.warning-message(v-if="!value.answer || !value.answer.firstName") 未入力
        span(v-else) {{ value.answer.firstName }}
        span （
        span.warning-message.mr-2(v-if="!value.answer || !value.answer.secondKanaName") 未入力
        span.mr-2(v-else) {{ value.answer.secondKanaName }}
        span.warning-message(v-if="!value.answer || !value.answer.firstKanaName") 未入力
        span(v-else) {{ value.answer.firstKanaName }}
        span ）

  PageLoading(:isBusy="isBusy" :message="loadingMessage")
</template>

<script lang="ts">
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";
import { userStore } from "@/store/store";
import Setting from "../../../../public/setting.json";

import {
  TemplateItem,
  TemplateType,
  TemplateItemBirthday,
  TemplateItemFile,
  TemplateItemInput,
  RoomType,
  TemplateItemRadio,
  TemplateItemSelect
} from "@/commons/services/AdmissionApplicationTemplates";
import { FacilityGetModel } from "@/commons/services/Facilities";
import S3UrlService from "@/commons/services/S3Url";
import ZipcloudService from "@/commons/services/Zipcloud";
import FileReaderWrapper from "@/commons/utils/FileReaderWrapper";

import PageLoading from "@/pc/basics/PageLoading.vue";
import HelpIcon from "@/pc/basics/HelpIcon.vue";
import PdfModal from "@/pc/basics/PdfModal.vue";
import ImageModal from "@/pc/basics/ImageModal.vue";
import ChildTemplateItem from "@/pc/containers/waiters/WaiterTemplateItem.vue";

/**
 * ### 待機者登録画面コンポーネント
 */
@Component({
  components: {
    PageLoading,
    HelpIcon,
    PdfModal,
    ImageModal,
    ChildTemplateItem
  },
  // 再帰呼び出しする場合、proビルド時にコンポーネント名が書き換えられて動かなくなるので明示的に定義する
  name: "WaiterTemplateItem"
})
export default class WaiterTemplateItem extends Vue {
  /** 親コンポーネントのバリデーターをInjectionする */
  @Inject("$validator") $validator!: Validator;

  /** S3Urlサービス */
  @Inject("S3UrlService") s3UrlService!: S3UrlService;
  /** zipcloudサービス */
  @Inject("ZipcloudService") zipcloudService!: ZipcloudService;

  /** テンプレート情報 */
  @Prop({ required: true })
  value!: TemplateItem;

  /** 閲覧可能施設 */
  @Prop({ required: true })
  waiterViewableFacilitiesMap!: Map<number, FacilityGetModel>;

  /** 子要素かどうか */
  @Prop({ required: true })
  isChaild!: boolean;

  /** ページ全体ローディング表示可否 */
  isBusy: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";

  /** type:address のエラーメッセージ */
  addressErrorMessage: string = "";

  /** type:file のPDFプレビューモーダル表示可否 */
  showPdfModal: boolean = false;
  /** type:file のPDFプレビューモーダルで表示する対象のURL */
  pdfModalUrl: string = "";
  /** type:file の画像プレビューモーダル表示可否 */
  showImageModal: boolean = false;
  /** type:file の画像プレビューモーダルで表示する対象のURL */
  imageModalUrl: string = "";
  /** type:file のエラーメッセージ */
  fileErrorMesage: string = "";

  get _margin(): string[] {
    if (this.isChaild == true) {
      return ["mr-3", "mb-3", "ml-3"];
    } else {
      return [""];
    }
  }

  /**
   * テキスト内の Markdown リンク記法 `link` を `<a>` タグに変換します。
   * クロスサイトスクリプティング（XSS）対策として、タグ変換前に HTML エスケープを行います。
   */
  public formatTextWithLink(text: string | undefined): string {
    if (!text) {
      return "";
    }

    // HTMLエスケープ処理
    let escapedText = text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");

    // Markdown リンク テキスト を <a> タグに変換
    const linkRegex = /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g;
    return escapedText.replace(linkRegex, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');
  }

  public isSection(item: TemplateItem): boolean {
    if (item.type != TemplateType.SECTION) {
      return false;
    }
    return true;
  }

  public isGroup(item: TemplateItem): boolean {
    if (item.type != TemplateType.GROUP) {
      return false;
    }
    return true;
  }

  public isText(item: TemplateItem): boolean {
    if (item.type != TemplateType.TEXT) {
      return false;
    }
    return true;
  }

  public isRadio(item: TemplateItem): boolean {
    if (item.type != TemplateType.RADIO) {
      return false;
    }
    return true;
  }

  public getRadioText(item: TemplateItemRadio): string {
    if (item == null) {
      return "";
    }

    for (const option of item.options) {
      if (option.value == item.answer) {
        return option.text;
      }
    }

    return "";
  }

  public isRadioGroup(item: TemplateItem): boolean {
    if (item.type != TemplateType.RADIO_GROUP) {
      return false;
    }
    return true;
  }

  public isSelect(item: TemplateItem): boolean {
    if (item.type != TemplateType.SELECT) {
      return false;
    }
    return true;
  }

  public getSelectText(item: TemplateItemSelect): string {
    if (item == null) {
      return "";
    }

    let answers: string[] = [];

    for (const answer of item.answer) {
      for (const option of item.options) {
        if (option.value == answer) {
          answers.push(option.text);
        }
      }
    }

    return answers.join("、");
  }

  public isCheckbox(item: TemplateItem): boolean {
    if (item.type != TemplateType.CHECKBOX) {
      return false;
    }
    return true;
  }

  public isSwitchCheckbox(item: TemplateItem): boolean {
    if (item.type != TemplateType.SWITCH_CHECKBOX) {
      return false;
    }
    return true;
  }

  public isMultipleCheckbox(item: TemplateItem): boolean {
    if (item.type != TemplateType.MULTIPLE_CHECKBOX) {
      return false;
    }
    return true;
  }

  public isTextarea(item: TemplateItem): boolean {
    if (item.type != TemplateType.TEXTAREA) {
      return false;
    }
    return true;
  }

  public isAddress(item: TemplateItem): boolean {
    if (item.type != TemplateType.ADDRESS) {
      return false;
    }
    return true;
  }

  public isBirthday(item: TemplateItem): boolean {
    if (item.type != TemplateType.BIRTHDAY) {
      return false;
    }
    return true;
  }

  public createAge(item: TemplateItemBirthday): number {
    const age: number = this.$dateUtil.convertBirthdayToAge(Number(item.answer.year), Number(item.answer.month), Number(item.answer.date));
    return age;
  }

  public isYearMonthDate(item: TemplateItem): boolean {
    if (item.type != TemplateType.YEAR_MONTH_DATE) {
      return false;
    }
    return true;
  }

  public isYearMonth(item: TemplateItem): boolean {
    if (item.type != TemplateType.YEAR_MONTH) {
      return false;
    }
    return true;
  }

  public isRoomType(item: TemplateItem): boolean {
    if (item.type != TemplateType.ROOM_TYPE) {
      return false;
    }
    return true;
  }

  public showRecruitement(roomType: RoomType): boolean {
    return (
      roomType.recruitmentRoom.multiBed ||
      roomType.recruitmentRoom.conventinalSingle ||
      roomType.recruitmentRoom.unitTypeSingle ||
      roomType.recruitmentRoom.double ||
      roomType.recruitmentRoom.single
    );
  }

  public showCustomRecruitment(roomType: RoomType): boolean {
    if (roomType.customRecruitmentRoom && 0 < roomType.customRecruitmentRoom.length) {
      for (const room of roomType.customRecruitmentRoom) {
        if (room.use == true) {
          return true;
        }
      }
    }
    return false;
  }

  public getFacilityName(roomType: RoomType): string {
    const facility: FacilityGetModel | undefined = this.waiterViewableFacilitiesMap.get(roomType.facilityId);

    if (!facility) {
      return "";
    }

    return facility.name;
  }

  public isFile(item: TemplateItem): boolean {
    if (item.type != TemplateType.FILE) {
      return false;
    }
    return true;
  }

  public isTel(item: TemplateItem): boolean {
    if (item.type != TemplateType.TEL) {
      return false;
    }
    return true;
  }

  public isName(item: TemplateItem): boolean {
    if (item.type != TemplateType.NAME) {
      return false;
    }
    return true;
  }

  public isRequired(item: TemplateItemInput): boolean {
    if (item.validationRules == null) {
      return false;
    }

    for (const validationRule of item.validationRules) {
      if (validationRule == "required") {
        return true;
      }
    }
    return false;
  }

  public async onFilePreview(item: TemplateItemFile, index: number): Promise<void> {
    if (item.tempAnswer == null || !item.answer) {
      return;
    }
    if (!item.tempAnswer[index] && (!item.answer || !item.answer[index])) {
      this.fileErrorMesage = "プレビュー非対応のファイル種別のため表示できません。";
      return;
    }

    // DBのデータ不正でtempAmswerにデータがあるが、正しいデータ形式ではない（fileNameまたはfileが無い）場合はtempAmswerをリセットする
    if (item.tempAnswer) {
      let isError = false;
      for (const file of item.tempAnswer) {
        if (!file.file || !file.fileName) {
          isError = true;
          break;
        }
      }
      if (isError) {
        item.tempAnswer = [];
      }
    }

    // tempAmswerにファイルが取得されていない場合、かつanswerにファイルURLが格納されていればその場で取得して格納する
    if (!item.tempAnswer![index] && item.answer) {
      this.isBusy = true;
      this.loadingMessage = "読込み中...";

      const tempFiles: Array<{
        file: File;
        fileName: string;
      }> = [];
      for (const targetFile of item.answer) {
        const s3File: File = await this.getS3File(targetFile.url, targetFile.name);
        tempFiles.push({
          file: s3File,
          fileName: s3File.name
        });
      }
      item.tempAnswer = tempFiles;

      this.isBusy = false;
    }

    switch (item.tempAnswer![index].file.type) {
      case "image/jpeg":
      case "image/png": {
        const url: string = await FileReaderWrapper.readAsDataURL(item.tempAnswer![index].file);
        this.imageModalUrl = url;
        this.showImageModal = true;
        break;
      }
      case "application/pdf": {
        const url: string = window.URL.createObjectURL(item.tempAnswer![index].file);
        this.pdfModalUrl = url;
        this.showPdfModal = true;
        break;
      }
      default: {
        this.fileErrorMesage = "プレビュー非対応のファイル種別のため表示できません。";
        break;
      }
    }

    return;
  }

  /**
   * ### S3に格納されているFileを取得する
   *
   * @param url 元URL
   */
  private async getS3File(url: string, fileName: string): Promise<File> {
    const response: File = await this.s3UrlService.getFile(userStore, Setting.backets.imageExpireHour, url, fileName);
    return response;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.template-view-item-component {
  .section-label,
  .item-label {
    font-weight: bold;
  }

  .section-text,
  .text {
    white-space: pre-wrap;
    word-wrap: break-word;
  }

  .template-group-item {
    .group-item {
      border: 1px solid #ced4da;
      border-radius: 0.25rem;
    }

    .group-delete-btn,
    .group-add-btn {
      font-size: 16px !important;
      height: 38px !important;
    }
  }

  .facility-only {
    background-color: rgba(245, 245, 245, 1);
    padding: 8px;
  }
  .facility-only-label {
    color: rgba(138, 138, 138, 1);
    font-size: 10px;
    border: 1px solid rgba(138, 138, 138, 1);
    padding: 1px 4px 0 4px;
    // 「必須」の文字が少し下にズレるでの、marginで調整する
    margin: 2px 6px 4px 0;
  }
  .validation-label {
    color: $validation-label-font-color;
    font-size: 10px;
    border: 1px solid $validation-label-font-color;
    padding: 1px 4px 0 4px;
    // 「必須」の文字が少し下にズレるでの、marginで調整する
    margin: 2px 6px 4px 0;
  }
  .noinput {
    background-color: $bg-require-input !important;
    &::placeholder {
      color: rgb(117, 117, 117);
    }
  }

  .template-item-radio-group {
    .radio-properties {
      border: 1px solid #ced4da;
      border-radius: 0.25rem;
    }
  }

  .template-item-checkbox {
    .checkbox {
      width: 24px;
      height: 24px;
    }
  }

  .template-item-switch-checkbox {
    .checkbox {
      width: 24px;
      height: 24px;
    }
    .checkbox-items {
      border: 1px solid #ced4da;
      border-radius: 0.25rem;
    }
  }

  .template-item-textarea {
    .item-textarea {
      .textarea {
        white-space: pre-wrap;
        word-wrap: break-word;
      }
    }
  }

  .template-item-address {
    .postal-code {
      width: 160px;
    }
    .search-address-btn {
      font-size: 16px !important;
      width: 100px !important;
      height: 38px !important;
    }
  }

  .template-item-birthday,
  .template-item-year-month-date {
    .year {
      width: 180px;
    }
    .month {
      width: 70px;
    }
    .date {
      width: 70px;
    }
  }

  .template-item-room-type {
    .facility-name {
      font-weight: bold;
    }
  }

  .template-item-file {
    // ファイル選択のボタンを他のボタンと同じデザインに変更する
    .template-file {
      ::after {
        background-color: $btn !important;
        color: $btn-font !important;
        height: 38px !important;

        &:hover,
        &:focus {
          background-color: $btn-hover !important;
          transition: background-color 0.25s ease-out, box-shadow 0.25s ease-out, color 0.25s ease-out;
        }
        &.disable {
          background-color: $btn-disable !important;
          transition: background-color 0.25s ease-out, box-shadow 0.25s ease-out, color 0.25s ease-out;
        }
        &:active {
          background-color: $btn-hover !important;
          transition: background-color 0.25s ease-out, box-shadow 0.25s ease-out, color 0.25s ease-out;
        }
        // .setlectedと組み合わせた場合のボタン色を指定する
        &.selected {
          background-color: $btn-selected !important;
          color: $btn-font-selected !important;
          transition: background-color 0.25s ease-out, box-shadow 0.25s ease-out, color 0.25s ease-out;
        }
        // .disableと組み合わせた場合のボタン色を指定する
        &.disable {
          cursor: not-allowed;
          background-color: $btn-disable !important;
          color: $btn-font-disable !important;
          transition: background-color 0.25s ease-out, box-shadow 0.25s ease-out, color 0.25s ease-out;
        }
      }
    }
    .file-preview-btn {
      font-size: 16px !important;
      width: 140px;
      height: 38px !important;
    }
  }
}
</style>
